export default __webpack_public_path__ + "static/media/fiat.564954bf.webp";